//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

// This is the client-side protection and should match the server-side checks done in BrandTags.scala (and in the mobile app).
const WINDOWS_1252_PATTERN =
  '[^\\u0000-\\u007FƒŠŒŽšœžŸªµº©™®\\u00c0-\\u00d6\\u00d8-\\u00f6\\u00f8-\\u00ff]';
const TAG_SANITIZE_PATTERN =
  WINDOWS_1252_PATTERN + '|[&,:;=@#|+?><~{}^()`/\\]\\[!$"%\\\'\\\\©®™.*]';
const MAX_TAG_LENGTH = 100;

const sanitizeTag = (tag: string) => {
  const tagRegex = new RegExp(TAG_SANITIZE_PATTERN, 'g');
  const strippedTag = tag.replace(tagRegex, '').toLowerCase();
  return encodeURIComponent(strippedTag);
};

export const isValidTag = (input: string) => {
  const regex = new RegExp(TAG_SANITIZE_PATTERN, 'g');
  return (
    input.length > 0 &&
    input
      .trim()
      .split(/[\s,]+/)
      .filter((item) => regex.test(item)).length === 0
  );
};

export const getSanitizedTags = (input: string) => {
  return input
    .trim()
    .split(/[\s,]+/)
    .map(sanitizeTag)
    .filter((item) => item.length > 0)
    .map((tag) => tag.substring(0, MAX_TAG_LENGTH));
};
